import React from 'react';
import './Header.css';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Header = () => {
    return (
        <Navbar className="header" fixed="top" collapseOnSelect expand="lg">
            <Container className="menu">
                <Navbar.Brand as={HashLink} to="/home#top" className="text-white">
                    HOME
                </Navbar.Brand>
                <Navbar.Toggle className="bg-light" aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto"></Nav>
                    <Nav className="menu">
                        <Nav.Link as={HashLink} to="/home#about">ABOUT</Nav.Link>
                        <Nav.Link as={HashLink} to="/home#portfolio">PORTFOLIO</Nav.Link>
                        <Nav.Link as={NavLink} to="/blogs">BLOGS</Nav.Link>
                        <Nav.Link as={HashLink} to="/home#contact">CONTACT</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;